import type { NamespaceSchema } from './types';

// Provider client IDs / secrets / redirect URIs all live in env
// (GOOGLE_OAUTH_CLIENT_ID etc.) — set those at deploy time. This
// namespace controls which buttons render on the storefront login.

export const socialAuthSettings: NamespaceSchema = {
  namespace: 'social-auth-settings',
  label: 'Social auth',
  description: 'Toggles which OAuth provider buttons render on the login page. Provider credentials are env-only.',
  sections: [
    {
      label: 'Visible providers',
      fields: [
        { kind: 'boolean', key: 'google_enabled', label: 'Google OAuth button visible', default: true },
        { kind: 'boolean', key: 'apple_enabled', label: 'Apple Sign-in button visible', default: false, description: 'Scaffolded but unfinished — see PRODUCTION_TODO.md.' },
        { kind: 'boolean', key: 'facebook_enabled', label: 'Facebook login button visible', default: false },
      ],
    },
  ],
};
